module.exports = __webpack_public_path__ + "static/media/fragezeichen.1b005726.png";